import React, { useEffect, useState } from 'react';
import Button from 'eymp-uicomps/components/Button';
import HeaderDetails from 'eymp-uicomps/components/HeaderDetails';
import { Grid } from '@material-ui/core';
import helpIcon from '../../../assets/dashboardIcons/helpIcon.png';
import InfoDialogue from '../../library/DialogueModal/InfoDialogue';
import styled from 'src/ui/library/styled';
import { DASHBOARD_URL, DEFAULT_DASHBOARD_VIEW, DEFAULT_SESSION_KEY } from '../../../constants/constants';
import { FormControlLabel, Switch } from '@material-ui/core';

const styles = () => ({
  switch: {
    '@global': {
      '.Mui-checked': {
        color: '#FFFF00',
      },
      '.MuiSwitch-track': {
        backgroundColor: '#FFFF00 !important',
      },
    },
  },
});

const HeaderNav = ({ classes, isProduction, showUserCompany, isConsentPage }) => {
  const [isOpen, setOpen] = useState(false);
  const [isDefaultView, setIsDefaultView] = useState(true);

  useEffect(() => {
    sessionStorage.setItem('case_nav', false);
    let default_view = sessionStorage.getItem(DEFAULT_SESSION_KEY);
    let isDefaultOldView =
      default_view === null
        ? (process.env.SHOW_DEFAULT_OLD_VIEW_ENV || 'false').toLowerCase() === 'true'
        : default_view.toLowerCase() === DEFAULT_DASHBOARD_VIEW.EXISTING.toLowerCase();
    sessionStorage.setItem(DEFAULT_SESSION_KEY, isDefaultOldView ? DEFAULT_DASHBOARD_VIEW.EXISTING : DEFAULT_DASHBOARD_VIEW.NEW);
    if (isDefaultOldView && window.location.pathname.toLowerCase().indexOf('new-dashboard') !== -1) {
      window.location.href = DASHBOARD_URL;
    }
    setIsDefaultView(isDefaultOldView);
  }, []);

  const handleCancel = () => {
    setOpen(false);
  };
  let isShowToggle = (process.env.SHOW_DASHBOARD_TOGGLE_ENV || 'false').toLowerCase() === 'true' ? true : false;

  const fnUpdateDashboardView = isDefaultOldView => {
    sessionStorage.setItem(DEFAULT_SESSION_KEY, isDefaultOldView ? DEFAULT_DASHBOARD_VIEW.EXISTING : DEFAULT_DASHBOARD_VIEW.NEW);
    window.location.href = DASHBOARD_URL;
  };

  const details = [
    {
      component: (
        <div>
          <Grid container className="align-items-center">
            <Grid item sm={showUserCompany ? 4 : 6}>
              <div className="align-items-baseline d-flex">
                <div className="logo-image">
                  <img alt="EY logo" src={process.env.PUBLIC_URL + '/images/EYLogo.svg'} />
                </div>
                <span className="header-iml">
                  <span>Mobility Pathway</span>
                </span>
              </div>
            </Grid>
            <Grid item sm={showUserCompany ? 4 : 6} className="text-align-end info-button-bg">
              {(isProduction ? null : !isShowToggle) || isConsentPage ? null : (
                <FormControlLabel
                  control={
                    <Switch
                      className={classes.switch}
                      color="secondary"
                      checked={isDefaultView}
                      onChange={() => fnUpdateDashboardView(!isDefaultView)}
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  }
                  label="Existing View"
                  labelPlacement="start"
                />
              )}

              <Button onClick={() => setOpen(true)}>
                <img src={helpIcon} alt="help" />
              </Button>
              {/* <InfoDialogue isOpen={isOpen} handleCancel={handleCancel}>DFDFBDFBDBDBBFDFB</InfoDialogue> */}
            </Grid>
          </Grid>
        </div>
      ),
    },
  ];
  return (
    <div>
      <HeaderDetails details={details} />
      <InfoDialogue title="Need Assistance?" isOpen={isOpen} handleCancel={handleCancel}>
        <div>
          <div>If you have any queries while using EY Mobility Pathway, please contact EY support at</div>
          <a href="mailto:pathway.support@ey.com">pathway.support@ey.com</a>
        </div>
      </InfoDialogue>
    </div>
  );
};

export default styled(HeaderNav)(styles);
